import { HTTPInstance } from '@/lib/http/http-instance'
import { RestaurantsListResponseModel } from './AuthorizationAPI.model'

class AuthorizationAPI {
  static getRestaurantsList = (): Promise<RestaurantsListResponseModel> =>
    HTTPInstance.get('/restaurants').then(response => response.data)
}

export default AuthorizationAPI
